import { createAsyncThunk } from "@reduxjs/toolkit";

import { fetchAllAnswers } from "../api/AnswerAndDiscussionApi";

export const fetchAllAnswersAsync = createAsyncThunk(
  "/fectchtotalCount",
  async ({ postId, page, PTECore }) => {
    const response = await fetchAllAnswers(postId, page, PTECore);
    return response.data;
  }
);
